import { render, staticRenderFns } from "./SelectTagsView.vue?vue&type=template&id=37bafdd9&scoped=true&"
import script from "./SelectTagsView.vue?vue&type=script&lang=ts&"
export * from "./SelectTagsView.vue?vue&type=script&lang=ts&"
import style0 from "./SelectTagsView.vue?vue&type=style&index=0&id=37bafdd9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37bafdd9",
  null
  
)

export default component.exports